import { PaginationMeta } from '../../../types/user.types';

export enum ActivityTypeEnum {
  BOXING = 'BOXING',
  STRENGTH = 'STRENGTH',
  RUNNING = 'RUNNING',
  OTHER = 'OTHER',
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type ActivitiesResponseDTO = {
  payload: Activity[];
  meta: PaginationMeta;
};

export interface ActivitiyResponseDTO {
  payload: Activity;
  meta: PaginationMeta;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type Activity = {
  checkInCode: string;
  description: string;
  id: string;
  isCheckedIn: boolean;
  scheduledDate: string;
  scheduledTime: string | null;
  title: string;
  type: ActivityTypeEnum;
};
